export default function () {
  this.clearForm()
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/mounted.js